var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Content",
    [
      _c(
        "div",
        { attrs: { id: "task_template" } },
        _vm._l(_vm.packagePanelConfigs, function (panelItem, index) {
          return _vm.packagePanelConfigs && _vm.packagePanelConfigs.length > 0
            ? _c(
                "Card",
                [
                  _c(
                    "Row",
                    { staticStyle: { "max-height": "40px" } },
                    [
                      _c(
                        "Col",
                        { attrs: { span: "24" } },
                        [
                          _c(
                            "FormItem",
                            { attrs: { label: "体检类型", "label-width": 70 } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "input-disabled",
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: "体检类型",
                                    disabled: _vm.packageDisabled,
                                    clearable: "",
                                    filterable: "",
                                    size: "small",
                                    transfer: "true",
                                    "popper-append-to-body": false,
                                  },
                                  on: {
                                    change: (val) => {
                                      _vm.changePhysicalType(val, panelItem)
                                    },
                                  },
                                  model: {
                                    value: _vm.medicalType,
                                    callback: function ($$v) {
                                      _vm.medicalType =
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                    },
                                    expression: "medicalType",
                                  },
                                },
                                _vm._l(_vm.physicalTypeList, function (item) {
                                  return _c("el-option", {
                                    key: item.code,
                                    staticStyle: {
                                      width: "100%",
                                      "z-index": "9999",
                                    },
                                    attrs: {
                                      label: item.name,
                                      value: item.code,
                                    },
                                    nativeOn: {
                                      click: function ($event) {
                                        return _vm.handlePhysicalType(item)
                                      },
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Row",
                    { staticStyle: { "max-height": "40px" } },
                    [
                      _c(
                        "Col",
                        { attrs: { span: "24" } },
                        [
                          _c(
                            "FormItem",
                            { attrs: { label: "体检套餐", "label-width": 70 } },
                            [
                              _c(
                                "el-select",
                                {
                                  staticClass: "input-disabled",
                                  staticStyle: { width: "100%" },
                                  attrs: {
                                    placeholder: "请选择体检套餐",
                                    disabled: _vm.packageDisabled,
                                    filterable: "",
                                    size: "small",
                                    transfer: "true",
                                    "popper-append-to-body": false,
                                  },
                                  nativeOn: {
                                    click: function ($event) {
                                      return ((val, propName) => {
                                        _vm.changePackages(val, propName, index)
                                      }).apply(null, arguments)
                                    },
                                  },
                                  model: {
                                    value:
                                      _vm.packagePanelConfigs[index].search,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.packagePanelConfigs[index],
                                        "search",
                                        typeof $$v === "string"
                                          ? $$v.trim()
                                          : $$v
                                      )
                                    },
                                    expression:
                                      "packagePanelConfigs[index].search",
                                  },
                                },
                                _vm._l(_vm.packagesNames, function (item) {
                                  return _c("el-option", {
                                    key: item.value,
                                    staticStyle: {
                                      width: "100%",
                                      "z-index": "9999",
                                    },
                                    attrs: {
                                      label: item.label,
                                      value: item.value,
                                    },
                                  })
                                }),
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  ((!_vm.medicalType || _vm.medicalType === 2) &&
                    _vm.bloodTubeShow &&
                    !_vm.packageDisabled) ||
                  (_vm.packageDisabled && _vm.bloodTubeRemark)
                    ? _c(
                        "Row",
                        { staticStyle: { "max-height": "40px" } },
                        [
                          _c(
                            "Col",
                            { attrs: { span: "24" } },
                            [
                              _c(
                                "FormItem",
                                { attrs: { label: "试管", "label-width": 70 } },
                                [
                                  _vm._l(_vm.bloodTubes, function (item) {
                                    return item.show && item.count > 0
                                      ? _c(
                                          "el-badge",
                                          {
                                            staticClass: "item",
                                            staticStyle: {
                                              "margin-right": "15px",
                                              "margin-bottom": "5px",
                                            },
                                            attrs: { value: item.count },
                                          },
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                style: {
                                                  "background-color":
                                                    item.color,
                                                  "border-color": item.color,
                                                  color: "#fff",
                                                },
                                                attrs: { size: "small" },
                                              },
                                              [_vm._v(_vm._s(item.name))]
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e()
                                  }),
                                  !_vm.packageDisabled
                                    ? _c(
                                        "el-button",
                                        {
                                          staticStyle: { color: "#409EFF" },
                                          attrs: { type: "text" },
                                          on: {
                                            click: function ($event) {
                                              _vm.bloodTubeWindow = true
                                            },
                                          },
                                        },
                                        [_vm._v("配置试管")]
                                      )
                                    : _vm._e(),
                                  !_vm.packageDisabled && _vm.bloodTubeClearShow
                                    ? _c(
                                        "el-button",
                                        {
                                          staticStyle: {
                                            "margin-left": "10px",
                                            color: "#f43f3b",
                                          },
                                          attrs: { type: "text" },
                                          on: { click: _vm.clearBloodTube },
                                        },
                                        [_vm._v("清空配置")]
                                      )
                                    : _vm._e(),
                                ],
                                2
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "Row",
                    [
                      _c(
                        "Col",
                        { attrs: { span: "24" } },
                        [
                          _c("TaskDetailEditTabPanel", {
                            key: `edp${index}`,
                            ref: "detailEditTabPanel",
                            refInFor: true,
                            attrs: {
                              "show-tabs": ["physicalProject", "lisProject"],
                              model: "table",
                              maxHeight: "430px",
                              packagesId: panelItem.search.packagesId,
                              taskProjects: panelItem.taskProjects,
                              taskLisProjects: panelItem.taskLisProjects,
                              projectIds: panelItem.projectIds,
                              lisProjectIds: panelItem.lisProjectIds,
                              medicalType: _vm.medicalType,
                              localApplicableAgeList: _vm.applicableAgeList,
                              disabled: _vm.packageDisabled
                                ? true
                                : !_vm.itemDisabled &&
                                  panelItem.search.packagesId &&
                                  panelItem.search.packagesId
                                ? false
                                : true,
                            },
                            on: {
                              "update:packagesId": function ($event) {
                                return _vm.$set(
                                  panelItem.search,
                                  "packagesId",
                                  $event
                                )
                              },
                              "update:packages-id": function ($event) {
                                return _vm.$set(
                                  panelItem.search,
                                  "packagesId",
                                  $event
                                )
                              },
                              "update:projectIds": function ($event) {
                                return _vm.$set(panelItem, "projectIds", $event)
                              },
                              "update:project-ids": function ($event) {
                                return _vm.$set(panelItem, "projectIds", $event)
                              },
                              "update:lisProjectIds": function ($event) {
                                return _vm.$set(
                                  panelItem,
                                  "lisProjectIds",
                                  $event
                                )
                              },
                              "update:lis-project-ids": function ($event) {
                                return _vm.$set(
                                  panelItem,
                                  "lisProjectIds",
                                  $event
                                )
                              },
                              "update:medicalType": function ($event) {
                                _vm.medicalType = $event
                              },
                              "update:medical-type": function ($event) {
                                _vm.medicalType = $event
                              },
                              setTaskProjects: _vm.setTaskProject,
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e()
        }),
        1
      ),
      _c(
        "Modal",
        {
          attrs: {
            width: "20%",
            title: "试管",
            styles: { top: "60px", "text-align": "center" },
            "mask-closable": false,
          },
          model: {
            value: _vm.bloodTubeWindow,
            callback: function ($$v) {
              _vm.bloodTubeWindow = $$v
            },
            expression: "bloodTubeWindow",
          },
        },
        [
          _vm._l(_vm.bloodTubeList, function (item) {
            return item.show
              ? _c(
                  "div",
                  {
                    staticStyle: {
                      "text-align": "left",
                      "margin-bottom": "8px",
                    },
                  },
                  [
                    _c(
                      "span",
                      { style: { color: item.color, "font-size": "16px" } },
                      [_vm._v(_vm._s(item.name) + " ")]
                    ),
                    _c("el-input-number", {
                      attrs: { min: 1, max: 9, label: "请输入试管根数" },
                      model: {
                        value: item.count,
                        callback: function ($$v) {
                          _vm.$set(item, "count", $$v)
                        },
                        expression: "item.count",
                      },
                    }),
                    _vm._v(" 根\n    "),
                  ],
                  1
                )
              : _vm._e()
          }),
          _c(
            "div",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.bloodTubeWindow = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "Button",
                { attrs: { type: "primary" }, on: { click: _vm.setBloodTube } },
                [_vm._v("确定")]
              ),
            ],
            1
          ),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }